import { http, type RequestHandler } from 'msw';

import { mockDataEndpoint } from './dataset-data';
import { mockOptionsEndpoint } from './dataset-options';
import { mockDatasetsEndpoint } from './datasets';
import { mockGeoEndpoint } from './geo';
import { mockSummaryEndpoint } from './summary';

export const api: Array<RequestHandler> = [
  http.get(`${process.env.API_BASE_URL}/api/datasets`, mockDatasetsEndpoint),
  http.get(
    `${process.env.API_BASE_URL}/api/:dataset/options`,
    mockOptionsEndpoint
  ),
  http.get(`${process.env.API_BASE_URL}/api/data`, mockDataEndpoint),
  http.get(`${process.env.API_BASE_URL}/api/summary`, mockSummaryEndpoint),
  http.get(`${process.env.API_BASE_URL}/api/geo`, mockGeoEndpoint),
];
